import Input from '../../components/Input'
import { onChange } from '../../utils/functions'
import { useDispatch } from 'react-redux'
import Button from '../../components/Button'
import Textarea from '../../components/Textarea'
import { useCloseTab } from '../../components/tabs/TabsContext'
import { toast } from 'react-toastify'
import { VALIDATION_MESSAGE } from '../../utils/constants'
import { useApiProgress } from '../../hooks/ApiProgress'
import { Fragment, useEffect, useState } from 'react'
import { Transition, Dialog } from '@headlessui/react'
import { FaPlus } from "react-icons/fa";
import { OUTSOURCER_PATH, getPageOutsourcers } from '../../api/outsourcerApi'
import useFirstRender from '../../hooks/FirstRender'
import { OPERATION_PATH, getPageOperations } from '../../api/operationApi'
import { PRODUCT_PATH, getPageProducts } from '../../api/productApi'
import { FaMinus } from "react-icons/fa6";
import { addProductionRecord } from '../../api/productionRecordApi'
import OutsourcerPicker from '../../components/outsourcer/OutsourcerPicker'
import OperationPicker from '../../components/operation/OperationPicker'
import ProductPicker from '../../components/product/ProductPicker'
import ProductLabel from '../../components/product/ProductLabel'
import PlanCard from '../../components/production-record/PlanCard'

const ProductionRecordAddPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const closeTab = useCloseTab()
    const isFirstRender = useFirstRender()
    const [outsourcerPage, setOutsourcerPage] = useState({
        content: []
    });

    const [outsourcer, setOutsourcer] = useState()
    const [productionDate, setProductionDate] = useState("")
    const [vat, setVat] = useState("")
    const [invoiceNumberIn, setInvoiceNumberIn] = useState("")
    const [invoiceNumberOut, setInvoiceNumberOut] = useState("")

    const [plans, setPlans] = useState([])

    const [plan, setPlan] = useState({
        operation: undefined,
        inputDetails: [],
        outputDetail: undefined
    })

    const [inputDetail, setInputDetail] = useState({ product: undefined, quantity: "" })

    const [outputDetail, setOutputDetail] = useState({ product: undefined, quantity: "" })

    const [outsourcerQuery, setOutsourcerQuery] = useState('')

    const [searchTimerOutsourcer, setSearchTimerOutsourcer] = useState();

    const pendingApiCallOutsourcer = useApiProgress('get', `${OUTSOURCER_PATH}/page`, false)

    const [errors, setErrors] = useState({})
    const [updatePlanIndex, setUpdatePlanIndex] = useState()

    const [isOpenPlanModal, setIsOpenPlanModal] = useState(false)

    const [operationPage, setOperationPage] = useState({
        content: []
    })

    const [productPage, setProductPage] = useState({
        content: []
    });

    const pendingApiCallOperation = useApiProgress('get', `${OPERATION_PATH}/page`, false)
    const pendingApiCallProduct = useApiProgress('get', `${PRODUCT_PATH}/page`, false)

    const [operationQuery, setOperationQuery] = useState('')
    const [productQuery, setProductQuery] = useState('')

    const [searchTimerOperation, setSearchTimerOperation] = useState();
    const [searchTimerProduct, setSearchTimerProduct] = useState();

    const searchingOperation = async (params) => {
        if (searchTimerOperation) clearTimeout(searchTimerOperation);
        let timer = setTimeout(() => {
            getPageOperations(params)
                .then(res => {
                    setOperationPage(res.data)
                })
        }, 500);
        setSearchTimerOperation(timer);
    }


    const searchingProduct = async (params) => {
        if (searchTimerProduct) clearTimeout(searchTimerProduct);
        let timer = setTimeout(() => {
            getPageProducts(params)
                .then(res => {
                    setProductPage(res.data)
                })
        }, 500);
        setSearchTimerProduct(timer);
    }



    const onClickLoadMoreOperation = () => {
        if (!operationPage.last) {
            loadOperations({ search: operationQuery, lastId: operationPage.content[operationPage.content.length - 1]?.id })
        }
    }

    const onClickLoadMoreProduct = () => {
        if (!productPage.last) {
            loadProducts({ search: productQuery, lastId: productPage.content[productPage.content.length - 1]?.id })
        }
    }

    const loadOperations = (params) => {
        !pendingApiCallOperation &&
            getPageOperations(params)
                .then(res => {
                    setOperationPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const loadProducts = (params) => {
        !pendingApiCallProduct &&
            getPageProducts(params)
                .then(res => {
                    setProductPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const searchingOutsourcer = async (params) => {
        if (searchTimerOutsourcer) clearTimeout(searchTimerOutsourcer);
        let timer = setTimeout(() => {
            getPageOutsourcers(params)
                .then(res => {
                    setOutsourcerPage(res.data)
                })
        }, 500);
        setSearchTimerOutsourcer(timer);
    }

    const onClickLoadMoreOutsourcer = () => {
        if (!outsourcerPage.last) {
            loadOutsourcers({ search: outsourcerQuery, lastId: outsourcerPage.content[outsourcerPage.content.length - 1]?.id })
        }
    }

    const loadOutsourcers = (params) => {
        !pendingApiCallOutsourcer &&
            getPageOutsourcers(params)
                .then(res => {
                    setOutsourcerPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    useEffect(() => {
        !isFirstRender && searchingOutsourcer({ search: outsourcerQuery })
    }, [outsourcerQuery])

    useEffect(() => {
        !isFirstRender && searchingOperation({ search: operationQuery })
    }, [operationQuery])

    useEffect(() => {
        !isFirstRender && searchingProduct({ search: productQuery })
    }, [productQuery])

    useEffect(() => {
        loadOutsourcers({ size: 20 })
        loadOperations({ size: 20 })
        loadProducts({ size: 20 })
    }, [])

    const onClickAddInputDetail = () => {
        if (inputDetail.product && inputDetail.quantity) {
            setPlan(prevState => ({ ...prevState, inputDetails: [...prevState.inputDetails, inputDetail] }))
        } else {
            toast.error('Lütfen verileri girin')
        }
    }

    const onClickRemoveInputDetail = (index) => {
        setPlan(prevState => ({ ...prevState, inputDetails: prevState.inputDetails.filter((d, i) => i !== index) }))
    }

    const onClickRemovePlan = (index) => {
        setPlans(prevState => prevState.filter((p, i) => i !== index))
    }

    const onClickRemoveOutputDetail = () => {
        setPlan(prevState => ({ ...prevState, outputDetail: undefined }))
    }

    const onClickAddOutputDetail = () => {
        setPlan(prevState => ({ ...prevState, outputDetail }))
    }

    const onClickAddPlan = () => {
        if (plan.operation && plan.inputDetails?.length > 0 && plan.outputDetail) {
            if (typeof updatePlanIndex === 'number') {
                setPlans(prevState => (prevState.map((p, i) => {
                    if (i === updatePlanIndex) return plan
                    else return p
                })))
                setUpdatePlanIndex(undefined)
            } else {
                setPlans(prevState => ([...prevState, plan]))
            }
            setPlan({ inputDetails: [] })
            setIsOpenPlanModal(false)
        } else {
            toast.error('Lütfen gerekli alanları doldurun')
        }
    }

    useEffect(() => {
        if (!isOpenPlanModal) {
            setPlan({ inputDetails: [] })
            setInputDetail({})
            setOutputDetail({})
        }

    }, [isOpenPlanModal])

    const onClickEditPlan = (index) => {
        setIsOpenPlanModal(true)
        const plan = plans[index]
        setPlan(plan)
        setOutputDetail(plan.outputDetail)
        setUpdatePlanIndex(index)
    }

    const onSubmit = () => {
        const plansBody = plans.map((plan) => {
            return {
                operationId: plan.operation?.id,
                inputDetails: plan.inputDetails.map((inputDetail) => {
                    return {
                        productId: inputDetail.product?.id,
                        quantity: inputDetail.quantity
                    }
                }),
                outputDetail: {
                    productId: plan.outputDetail.product?.id,
                    quantity: plan.outputDetail.quantity
                },
                description: plan.description
            }
        })

        const productionRecordBody = {
            outsourcerId: outsourcer?.id,
            productionDate,
            vat,
            invoiceNumberOut,
            invoiceNumberIn,
            plans: plansBody
        }

        addProductionRecord(productionRecordBody)
            .then(res => {
                toast.success('Üretim kaydı kaydedildi')
                closeTab()
            }).catch(err => {
                setErrors(err.response.data.validationErrors)
                toast.error(VALIDATION_MESSAGE)
            })
    }

    useEffect(() => {
        setErrors((prevState) => ({ ...prevState, plans: undefined }))
    }, [plans])

    return (
        <div>
            <div className='mb-5'>
                <label className='text-xl'>Yeni Üretim</label>
            </div>
            <div className='grid grid-cols-12 gap-x-3 mb-10'>
                {/* OUTSOURCER PICKER */}
                <OutsourcerPicker
                    label='Fasoncu'
                    pendingApiCall={pendingApiCallOutsourcer}
                    state={outsourcer}
                    setState={(value) => setOutsourcer(value)}
                    query={outsourcerQuery}
                    setQuery={setOutsourcerQuery}
                    error={errors.outsourcerId}
                    page={outsourcerPage}
                    setErrors={() => setErrors(prevState => ({ ...prevState, outsourcerId: undefined }))}
                    onClickClear={() => setOutsourcer()}
                    onClickLoadMore={() => onClickLoadMoreOutsourcer()}
                />
                <div className='col-span-2'>
                    <Input
                        name='productionDate'
                        label='Üretim Tarihi'
                        type='date'
                        value={productionDate}
                        error={errors?.productionDate}
                        onChange={e => setProductionDate(e.target.value)}
                    />
                </div>
                <div className='col-span-2'>
                    <Input
                        name='vat'
                        label='Vergi Oranı (%)'
                        type='number'
                        placeholder='Vergi oranı...'
                        value={vat}
                        error={errors?.vat}
                        onChange={e => setVat(e.target.value)}
                    />
                </div>
                <div className='col-span-2'>
                    <Input
                        name='invoiceNumberOut'
                        label='Fatura numarası çıkış'
                        type='text'
                        placeholder='Fatura numarası çıkış...'
                        value={invoiceNumberOut}
                        error={errors?.invoiceNumberOut}
                        onChange={e => setInvoiceNumberOut(e.target.value)}
                    />
                </div>
                <div className='col-span-2'>
                    <Input
                        name='invoiceNumberIn'
                        label='Fatura numarası giriş'
                        type='text'
                        placeholder='Fatura numarası giriş...'
                        value={invoiceNumberIn}
                        error={errors?.invoiceNumberIn}
                        onChange={e => setInvoiceNumberIn(e.target.value)}
                    />
                </div>
            </div>
            <div className='mb-5'>
                <div className='flex gap-x-2 items-center'>
                    <label className='text-lg'>Üretim Planları</label>
                    <FaPlus className='cursor-pointer' onClick={() => setIsOpenPlanModal(true)} />
                </div>
                {errors.plans && <label className='text-red-700 text-sm'>{errors.plans} </label>}
                {/* PlANS */}
                <div className='grid grid-cols-3 gap-x-5 mb-10'>
                    {
                        plans.map((plan, index) => (
                            <PlanCard
                                key={index}
                                plan={plan}
                                onClickEdit={() => onClickEditPlan(index)}
                                onClickTrash={() => onClickRemovePlan(index)}
                            />
                        ))
                    }

                </div>
                <div>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onSubmit}
                    />
                </div>

            </div>

            {/* MODAL */}
            <Transition appear show={isOpenPlanModal} as={Fragment}>
                <Dialog as="div" onClose={() => setIsOpenPlanModal(false)}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-2xl transform rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg font-medium leading-6 text-gray-900 mb-5"
                                    >
                                        Yeni Plan
                                    </Dialog.Title>
                                    <div className='mb-5'>
                                        <OperationPicker
                                            label='İşlem'
                                            pendingApiCall={pendingApiCallOperation}
                                            state={plan.operation}
                                            setState={(value) => setPlan(prevState => ({ ...prevState, operation: value }))}
                                            query={operationQuery}
                                            setQuery={setOperationQuery}
                                            error={errors.operationId}
                                            page={operationPage}
                                            setErrors={prevState => ({ ...prevState, outsourcerId: undefined })}
                                            onClickClear={() => setPlan(prevState => ({ ...prevState, operation: undefined }))}
                                            onClickLoadMore={() => onClickLoadMoreOperation()}
                                        />
                                    </div>
                                    {/* INPUT DETAILS */}
                                    <div className='p-2 border shadow-md rounded-md mb-10'>
                                        <label className='mb-3 block'>Gidecek Ürünler</label>
                                        <div className='mb-5 border-b'>
                                            {
                                                plan.inputDetails?.map((inputDetail, index) => (
                                                    <div key={index} className='mb-2 grid grid-cols-12 gap-x-2 bg-purple-100 p-2 rounded-md'>
                                                        <div className='col-span-1'>
                                                            {index + 1}.
                                                        </div>
                                                        <div className='col-span-8'>
                                                            <ProductLabel state={inputDetail.product} />
                                                        </div>
                                                        <div className='col-span-2 text-center text-sm'>
                                                            {inputDetail.quantity} m
                                                        </div>
                                                        <div className='col-span-1 flex justify-center self-center'>
                                                            <FaMinus className='cursor-pointer' onClick={() => onClickRemoveInputDetail(index)} />
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        {/* INPUT_DETAIL PRODUCT PICKER */}
                                        <div className='grid grid-cols-12 gap-x-2 items-center'>
                                            <div className='col-span-8'>
                                                <ProductPicker
                                                    label='Ürün'
                                                    pendingApiCall={pendingApiCallProduct}
                                                    state={inputDetail.product}
                                                    setState={(value) => setInputDetail(prevState => ({ ...prevState, product: value }))}
                                                    query={productQuery}
                                                    setQuery={setProductQuery}
                                                    error={errors.productId}
                                                    page={productPage}
                                                    setErrors={prevState => ({ ...prevState, productId: undefined })}
                                                    onClickClear={() => setInputDetail(prevState => ({ ...prevState, product: undefined }))}
                                                    onClickLoadMore={() => onClickLoadMoreProduct()}
                                                />
                                            </div>
                                            <div className='col-span-3'>
                                                <Input
                                                    label='Metre'
                                                    name="quantity"
                                                    type='number'
                                                    placeholder='Metre'
                                                    value={inputDetail.quantity}
                                                    onChange={e => onChange(e, setInputDetail)}
                                                />
                                            </div>
                                            <div className='col-span-1 mb-3 text-center justify-center flex'>
                                                <FaPlus className='cursor-pointer' onClick={onClickAddInputDetail} />
                                            </div>
                                        </div>
                                    </div>

                                    {/* OUTPUT DETAIL */}
                                    <div className='p-2 border shadow-md rounded-md mb-10'>
                                        <label className='mb-3 block'>Beklenen Ürün</label>

                                        {
                                            plan.outputDetail
                                                ?
                                                <div className='mb-2 grid grid-cols-12 gap-x-2 bg-purple-100 p-2 rounded-md'>
                                                    <div className='col-span-1'></div>
                                                    <div className='col-span-8'>
                                                        <ProductLabel state={outputDetail.product} />
                                                    </div>
                                                    <div className='col-span-2 text-center text-sm'>
                                                        {plan.outputDetail.quantity} m
                                                    </div>
                                                    <div className='col-span-1 flex justify-center self-center'>
                                                        <FaMinus className='cursor-pointer' onClick={() => onClickRemoveOutputDetail()} />
                                                    </div>
                                                </div>
                                                : <div>
                                                    <div className='grid grid-cols-12 gap-x-2 items-center'>
                                                        <div className='col-span-8'>
                                                            <ProductPicker
                                                                label='Ürün'
                                                                pendingApiCall={pendingApiCallProduct}
                                                                state={outputDetail.product}
                                                                setState={(value) => setOutputDetail(prevState => ({ ...prevState, product: value }))}
                                                                query={productQuery}
                                                                setQuery={setProductQuery}
                                                                error={errors.productId}
                                                                page={productPage}
                                                                setErrors={prevState => ({ ...prevState, productId: undefined })}
                                                                onClickClear={() => setOutputDetail(prevState => ({ ...prevState, product: undefined }))}
                                                                onClickLoadMore={() => onClickLoadMoreProduct()}
                                                            />
                                                        </div>
                                                        <div className='col-span-3'>
                                                            <Input
                                                                label='Metre'
                                                                name="quantity"
                                                                type='number'
                                                                placeholder='Metre'
                                                                value={outputDetail.quantity}
                                                                onChange={e => onChange(e, setOutputDetail)}
                                                            />
                                                        </div>
                                                        <div className='col-span-1 mb-3 text-center justify-center flex'>
                                                            <FaPlus className='cursor-pointer' onClick={onClickAddOutputDetail} />
                                                        </div>
                                                    </div>
                                                </div>
                                        }
                                    </div>
                                    <Textarea
                                        label='Açıklama'
                                        name='description'
                                        value={plan.description}
                                        onChange={e => onChange(e, setPlan)}
                                        placeholder='Açıklama girin...'
                                    />
                                    <div className="mt-4 flex justify-between">
                                        <button
                                            type="button"
                                            className="flex items-center outline-none inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200"
                                            onClick={() => setIsOpenPlanModal(false)}
                                        >
                                            İptal

                                        </button>
                                        <button
                                            type="button"
                                            className="outline-none inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 disabled:bg-blue-100"
                                            onClick={onClickAddPlan}
                                        //disabled={!variation.color && !variation.pattern && !variation.weight}
                                        >
                                            Ekle
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </div>
    )
}

export default ProductionRecordAddPage